export default {
  hotels: [
    require('./images/hotels/sf_hotel_0.jpg'),
    require('./images/hotels/sf_hotel_1.jpg'),
    require('./images/hotels/sf_hotel_2.jpg'),
    require('./images/hotels/sf_hotel_3.jpg'),
    require('./images/hotels/sf_hotel_4.jpg'),
    require('./images/hotels/sf_hotel_5.jpg'),
    require('./images/hotels/sf_hotel_6.jpg'),
    require('./images/hotels/sf_hotel_7.jpg'),
    require('./images/hotels/sf_hotel_8.jpg'),
    require('./images/hotels/sf_hotel_9.jpg'),
    require('./images/hotels/sf_hotel_10.jpg'),
    require('./images/hotels/sf_hotel_11.jpg'),
    require('./images/hotels/sf_hotel_12.jpg'),
    require('./images/hotels/sf_hotel_13.jpg'),
    require('./images/hotels/sf_hotel_14.jpg') ,
    require('./images/hotels/sf_hotel_15.jpg'),
    require('./images/hotels/sf_hotel_16.jpg'),
    require('./images/hotels/sf_hotel_17.jpg'),
    require('./images/hotels/sf_hotel_18.jpg'),
    require('./images/hotels/sf_hotel_19.jpg')
  ],
  attractions: [
    require('./images/attractions/sf_attraction_0.jpg'),
    require('./images/attractions/sf_attraction_1.jpg'),
    require('./images/attractions/sf_attraction_2.jpg'),
    require('./images/attractions/sf_attraction_3.jpg'),
    require('./images/attractions/sf_attraction_4.jpg'),
    require('./images/attractions/sf_attraction_5.jpg'),
    require('./images/attractions/sf_attraction_6.jpg'),
    require('./images/attractions/sf_attraction_7.jpg'),
    require('./images/attractions/sf_attraction_8.jpg'),
    require('./images/attractions/sf_attraction_9.jpg'),
    require('./images/attractions/sf_attraction_10.jpg'),
    require('./images/attractions/sf_attraction_11.jpg'),
    require('./images/attractions/sf_attraction_12.jpg'),
    require('./images/attractions/sf_attraction_13.jpg'),
    require('./images/attractions/sf_attraction_14.jpg'),
    require('./images/attractions/sf_attraction_15.jpg'),
    require('./images/attractions/sf_attraction_16.jpg'),
    require('./images/attractions/sf_attraction_17.jpg'),
    require('./images/attractions/sf_attraction_18.jpg'),
    require('./images/attractions/sf_attraction_19.jpg')
  ],
  restaurants : [
    require('./images/restaurants/sf_restaurant_0.jpg'),
    require('./images/restaurants/sf_restaurant_1.jpg'),
    require('./images/restaurants/sf_restaurant_2.jpg'),
    require('./images/restaurants/sf_restaurant_3.jpg'),
    require('./images/restaurants/sf_restaurant_4.jpg'),
    require('./images/restaurants/sf_restaurant_5.jpg'),
    require('./images/restaurants/sf_restaurant_6.jpg'),
    require('./images/restaurants/sf_restaurant_7.jpg'),
    require('./images/restaurants/sf_restaurant_8.jpg'),
    require('./images/restaurants/sf_restaurant_9.jpg'),
    require('./images/restaurants/sf_restaurant_10.jpg'),
    require('./images/restaurants/sf_restaurant_11.jpg'),
    require('./images/restaurants/sf_restaurant_12.jpg'),
    require('./images/restaurants/sf_restaurant_13.jpg'),
    require('./images/restaurants/sf_restaurant_14.jpg'),
    require('./images/restaurants/sf_restaurant_15.jpg'),
    require('./images/restaurants/sf_restaurant_16.jpg'),
    require('./images/restaurants/sf_restaurant_17.jpg'),
    require('./images/restaurants/sf_restaurant_18.jpg'),
    require('./images/restaurants/sf_restaurant_19.jpg')
  ]
}
